(() => {
  const FORM_SELECTOR = 'form[data-newsletter-signup="true"]';

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/(["\\])/g, '\\$1');
  }

  function submitButtons(form) {
    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));

    if (form.id) {
      const escapedId = selectorEscape(form.id);
      buttons.push(...document.querySelectorAll(`[type="submit"][form="${escapedId}"]`));
    }

    return Array.from(new Set(buttons));
  }

  function setLoading(form) {
    submitButtons(form).forEach((button) => {
      if (button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('newsletter-submit--loading');
      button.replaceChildren();

      const spinner = document.createElement('span');
      spinner.className = 'newsletter-submit__spinner';
      spinner.setAttribute('aria-hidden', 'true');

      const label = document.createElement('span');
      label.textContent = 'Submitting…';

      button.append(spinner, label);
    });
  }

  function openDrawer(surface) {
    const drawerId = surface === 'nav' ? 'sidebar-menu' : 'cart-drawer';
    const drawer = document.getElementById(drawerId);

    if (!drawer || drawer.hasAttribute('open')) return;

    const trigger = document.querySelector(`[aria-controls="${drawerId}"]`);
    if (trigger) trigger.click();
  }

  function showPostedSuccess() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true' || !window.location.hash) return;

    let formId;

    try {
      formId = decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return;
    }

    const form = document.getElementById(formId);
    if (!form || !form.matches(FORM_SELECTOR)) return;

    const escapedId = selectorEscape(formId);
    const region = document.querySelector(`[data-newsletter-region-for="${escapedId}"]`) || form;
    const successMessage = region.querySelector('[data-newsletter-success]');
    const formContent = region.querySelector('[data-newsletter-content]');

    if (!successMessage) return;

    if (formContent) formContent.hidden = true;
    successMessage.hidden = false;

    const surface = form.dataset.newsletterSurface;
    if (surface === 'nav' || surface === 'cart-drawer') openDrawer(surface);

    window.setTimeout(() => successMessage.focus(), surface === 'nav' || surface === 'cart-drawer' ? 450 : 0);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      form.addEventListener('submit', () => setLoading(form));
    });

    showPostedSuccess();
  });
})();
